import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { FC } from 'react';
import { Button } from 'src/common/components/button';
import { useModel } from 'src/common/create-model';
import { bindDataTestId, TestIds } from 'src/utils/qa-utils';
import { SettingModalCommon, SettingProvider } from '../common';
import { useCloseSettingModal } from '../use-open-setting-modal';
import { CommentSetting } from './comment-setting';
import { DateSetting } from './date-setting';
import { FormNotificationSetting } from './form-notification-setting';
import { LinkPage } from './link-page';
import { PageAd } from './page-ad';
import { PageIconSetting } from './page-icon-setting';
import { SpaceAvatar } from './space-avatar';
import { SpaceDomain } from './space-domain';
import { SpaceHome } from './space-home';
import { SpaceName } from './space-name';
import { SpaceSecurity } from './space-security';
import { TemplateRecommendSetting } from './template-recommend-setting';
// import { SpaceSecurity } from './space-security';

/** 空间设置 */
export const SpaceSetting: FC = () => {
  const { t } = useAppTranslation();
  const closeSettingModal = useCloseSettingModal();
  const { spaceSettingState } = useModel(SettingProvider);
  const {
    saveSpaceSetting,
    leavingSpace,
    handleDeleteSpace,
    isLastEditorUser,
    icon,
    setIcon,
    spaceEditor,
    isGuest,
    freeTeam,
  } = spaceSettingState;

  if (!spaceEditor) {
    return (
      <>
        <div className={SettingModalCommon.commonStyles.container}>
          <SettingModalCommon.Header title={t('common.space_settings')} />

          <div className="text-t3 text-grey3 mt-2">
            {isGuest
              ? t('components.space_setting.guest_permission_tip')
              : t('components.space_setting.member_permission_tip')}
          </div>

          <Button onClick={leavingSpace} className="text-t2-medium mt-5 ml-auto">
            {t('components.space_setting.leave_space')}
          </Button>
        </div>
        <SettingModalCommon.FooterBar
          cancel={() => closeSettingModal()}
          cancelText={t('common.close')}
        />
      </>
    );
  }

  return (
    <>
      <div className={SettingModalCommon.commonStyles.container}>
        <SettingModalCommon.Header
          title={t('common.space_settings')}
          name={t('components.space_setting.space_avatar')}
        />
        <SpaceAvatar icon={icon} setIcon={setIcon} />

        <SpaceName />

        {!__PRIVATE__ && <SpaceDomain />}

        {!__PRIVATE__ && <SpaceHome />}

        <DateSetting />
        <FormNotificationSetting />

        {!__PRIVATE__ && <PageAd />}

        <LinkPage />

        {/* <SettingCapacity /> */}
        <CommentSetting />
        <SpaceSecurity />

        <TemplateRecommendSetting />
        <PageIconSetting />

        {/* {!__PRIVATE__ && <FlowUsAISetting />} */}

        <div className="mt-4 flex justify-end">
          {freeTeam && !isLastEditorUser && (
            <Button
              className="mr-5"
              {...bindDataTestId(TestIds.settingSpaceDelete)}
              onClick={leavingSpace}
            >
              {t('components.space_setting.leave_space')}
            </Button>
          )}
          <Button
            {...bindDataTestId(TestIds.settingSpaceDelete)}
            colorType="red"
            className="mb-10"
            onClick={handleDeleteSpace}
          >
            {t('common.delete_space')}
          </Button>
        </div>
      </div>

      <SettingModalCommon.FooterBar cancel={() => closeSettingModal()} confirm={saveSpaceSetting} />
    </>
  );
};
